import { useEffect, useState } from 'react';

import { musicGenreOptions } from '../../shared/music-genres';

export type MusicGenreOption = readonly [string, string];

export function useMusicGenreOptions() {
  const [options, setOptions] = useState<readonly MusicGenreOption[]>(musicGenreOptions);
  useEffect(() => {
    let active = true;
    void fetch('/api/v1/genres', { headers: { Accept: 'application/json' } })
      .then((response) => (response.ok ? response.json() : null))
      .then((body: { genres?: Array<{ code: string; name: string }> } | null) => {
        if (active && body?.genres)
          setOptions(body.genres.map((item) => [item.code, item.name] as const));
      });
    return () => {
      active = false;
    };
  }, []);
  return options;
}
